import { toggleElementsVisibilityById, toggleElementVisibilityById } from '@vfde-brix/ws10/core';
import { OverlayContent } from '../enums/elementId';

export const updateOverlayContent = (activeUI: OverlayContent) => {
    toggleElementsVisibilityById(Object.values(OverlayContent), false);
    toggleElementVisibilityById(activeUI);
};
